import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropType from 'prop-types';

export class PartnerListing extends Component {
  render() {
    const { t, data } = this.props;
    return (
      <div className="partner-listing">
        {data.map(d => (
        <a className="partner-listing-item" href={"/partners/#" + encodeURIComponent(d.id)} key={d.id}>
          <img className="partner-listing-item-icon" src={d.icon}></img>
          <div className="partner-listing-item-text">{d.title}</div>
        </a>
        ))}
      </div>
    );
  }
}

PartnerListing.defaultProps = {
  t: (str) => str,
  data: [],
};

PartnerListing.propTypes = {
  t: PropType.func,
  data: PropType.arrayOf(PropType.object),
};

export default translate()(PartnerListing);
